import { TranslationsContext } from '@teliaee/telia-translate';
import React from 'react';
import { AnalyticsTrigger, Button, Card, CardContent, EqualHeight, Heading, Icon, Separator, THeadingLevel } from 'telia-front-react';

interface B2BLoyaltyCardProps {
  icon: string;
  suffix: string;
  ctaBaseUrl?: string;
  headingLevel?: THeadingLevel;
}

const B2BLoyaltyCard = (props: B2BLoyaltyCardProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const { icon, suffix, ctaBaseUrl, headingLevel } = props;

  return (
    <Card background="neutral-bg-level-1">
      <CardContent>
        <EqualHeight group="heading">
          <Icon size="sm" modifiers={icon} />
          <Heading className="h4" level={headingLevel}>
            {translate(`personalOffers.b2b.loyalty.title.${suffix}`)}
          </Heading>
          <Separator spacing="xxsmall" color="invisible" />
        </EqualHeight>
        <EqualHeight group="content">{translate(`personalOffers.b2b.loyalty.content.${suffix}`)}</EqualHeight>
        <EqualHeight group="cta-button">
          <Separator spacing="xsmall" color="invisible" />
          <AnalyticsTrigger
            trigger={{
              id: `Link - Telia Äriklass ${suffix}`,
              callback: 'onClick',
            }}
          >
            <Button
              text={translate(`personalOffers.b2b.loyalty.cta.text.${suffix}`)}
              iconRight="#arrow-right"
              block={true}
              variant="secondary"
              url={translate(`personalOffers.b2b.loyalty.cta.url.${suffix}`, {
                baseUrl: ctaBaseUrl,
              })}
            />
          </AnalyticsTrigger>
        </EqualHeight>
      </CardContent>
    </Card>
  );
};

export default B2BLoyaltyCard;
